export interface OfferLoginData {
  productId: number;
  offeredPrice: string;
}

export default class OfferLoginService {
  private OFFER_LOGIN_DATA_STORAGE_KEY = 'offerLoginData';

  public setOfferData(data: OfferLoginData) {
    localStorage.setItem(this.OFFER_LOGIN_DATA_STORAGE_KEY, JSON.stringify(data));
  }

  public getOfferData(): OfferLoginData | null {
    const raw = localStorage.getItem(this.OFFER_LOGIN_DATA_STORAGE_KEY);

    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw) as OfferLoginData;
    } catch {
      // Malformed data — drop it so we don't keep failing to parse it on every load
      this.clearOfferData();

      return null;
    }
  }

  public clearOfferData() {
    localStorage.removeItem(this.OFFER_LOGIN_DATA_STORAGE_KEY);
  }
}
